import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

export type MapAccountResponse = (
    | {
          outcome: 'success';
          original: {
              accountId: string;
              entityEntityAccountId: string;
          };
      }
    | {
          outcome: 'failed';
          reason: string;
          original: {
              accountId: string;
              entityEntityAccountId: string;
          };
      }
)[];
type MapAccountRequest = {
    accountId: string;
    entityAccountId?: string;
}[];

async function mapWorkpaperAccounts(workpaperId: string, mappings: MapAccountRequest): Promise<MapAccountResponse> {
    const { data } = await api.post(`/workpapers/${workpaperId}/account-mappings`, mappings);
    return data;
}

export function useMapWorkpaperAccounts(
    workpaperId: string
): UseMutationResult<MapAccountResponse, AxiosError<MapAccountResponse | { message: string }>, MapAccountRequest, unknown> {
    return useMutation((m) => mapWorkpaperAccounts(workpaperId, m), {
        onSettled: () => {
            queryClient.invalidateQueries(['workpapers', workpaperId, 'accounts']);
        },
    });
}
